import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { message, Switch, Select, Form, Input, Row, Col, DatePicker, Upload, Space, Button } from 'antd';
import Modal from 'react-bootstrap/Modal';
import { app } from '../../config';
import getHeaders from '../../utils/authHeaders';
import TextArea from 'antd/lib/input/TextArea';
import { AddRecord } from '../../layouts/AddRecord';
import { InputField, SelectField, TextAreaField } from '../../layouts/FormFields';
import TagInput from '../Products/TagInput';
import { InfoCircleOutlined, LoadingOutlined, UploadOutlined } from '@ant-design/icons';
import getSampleVideoType from '../../hooks/getSampleVideoType';
import AddPhoto from '../../assets/images/add.png';
import TestComponent from '../Products/TestComponent';
import { MdError } from 'react-icons/md';
import { BiSolidError } from 'react-icons/bi';
import getAllProductCategories from '../../hooks/getAllProductCategories';
import { UpdateRecord } from '../../layouts/UpdateRecord';
import TagSelect from '../Products/TagSelect';
import moment from 'moment';

const EditSubscription = () => {
  const { t } = useTranslation(['common']);
  const [addUserResp, setAddUserResp] = useState({});
  const [show, setShow] = useState(false);
  const [uploadedImg, setUploadedImg] = useState('');
    const [imageuploading, setImageUploading] = useState(false);
    const [imgError, setImgError] = useState(false);
  const [productsdata, setproductsdata] = useState([])
    const [updatedDataa, setUpdatedData] = useState({});
  
const [durationdata, setdurationdata] = useState([]);
  const[isActive,setisActive]=useState(true)
  const [largeFile, setLargeFile] = useState(false);
  const productCategoriesRes = getAllProductCategories();
  const [productCat, setProductCat] = useState([]);

  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [uploadVideo, setuploadVideo] = useState('');
  const [contentType, setContentType] = useState();
  const [uplVid, setuplVid] = useState(true);

  const [facialScandata, setfacialScandata] = useState([]);
   const [frequencydata, setfrequencydata] = useState([]);
    const [durationId, setdurationId] = useState();
  
  const sampleVideoRes = getSampleVideoType();

  const productCategories = productCategoriesRes.response ? productCategoriesRes.response.data : [];
  
  // const [imageuploading, setimageuploading] = useState(false);
  // const [uploadImage, setuploadImage] = useState('');
  ;
      const [categoryId, setcategoryId] = useState();

  let header = getHeaders();
    const [prodDescription, setProdDescription] = useState();

  // const sampleVideo = sampleVideoRes.response ? sampleVideoRes.response : [];
  // console.log(sampleVideo);

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    // reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };
   const beforeUpload = (file) => {
     console.log(file);
     if (file) {
       const img = new Image();
       img.src = URL.createObjectURL(file);
       img.onload = () => {
           if (img.width < 700 || img.width > 1100 || img.height < 1100 || img.height > 2000) {
             setImgError(true);
             return null;
           } else {
             setImgError(false);

             if (file.type === 'image/jpeg' || file.type === 'image/png') {
               console.log('setting image type');
               setContentType('img');
             } else if (file.type === 'video/x-matroska' || file.type === 'video/mp4') setContentType('video');
             const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'video/x-matroska' || file.type === 'video/mp4';
             if (!isJpgOrPng) {
               message.error('You can only upload JPG/PNG file!');
             }
             console.log('file Checked');
             const isLt2M = file.size / 1024 / 1024 < file.type === 'video/mp4' ? 200 : 20;
             if (!isLt2M) {
               setLargeFile(true);
               message.error('Image must smaller than 20MB!');
             }
             console.log('message');
             return isJpgOrPng && isLt2M;
           }
       };
     }
   };
 const handleChange = (info) => {
   if (info.file.status === 'uploading') {
     console.log('uploading data');
     if (!imgError) {
       setUploadedImg('');
       setImageUploading(true);
      //  setLoading(true);
       return;
     } else {
       setImageUploading(false);
       setLoading(false);
       return;
     }
   }
   if (info.file.status === 'done' && !imgError) {
     // Get this url from response in real world.
     setLargeFile(false);
     console.log(info.file.response);
     info.file ? console.log(info.file.response.result.data.Location) : console.log('Not found');
     info.file ? setUploadedImg(info.file.response.result.data.Location) : ' ';
     info.file ? setImageUploading(false) : ' ';

     getBase64(info.file.originFileObj, (url) => {
       setLoading(false);
       setImageUploading(false);
      //  setuploadLogo(false);
     });
   }
  };
  const getproductsusingCategoryId = async (id) => {
    try {
      const res = await axios.get(`${app.URL}/api/v1/admin/product/getproducts?productCategoryId=${id}`, { headers: getHeaders() });
      // const res = await axios.get(`http://192.168.100.16:3200/api/v1/admin/product/getproducts?productCategoryId=${id}`, { headers: getHeaders() });
      console.log('response', res);

      console.log("response", res.data.result.data)
      if (res.status == 200) {
        setproductsdata(res.data.result.data);
      }
     
      
    } catch (error) {
      console.log(error)
      return
    }
    
  }
   const getdurations = async (id) => {
     try {
       // const res = await axios.get(`${app.URL}/api/v1/admin/product/getproducts?productCategoryId=${id}`, { headers: getHeaders() });
       const res = await axios.get(`${app.URL}/api/v1/admin/duration/get`, { headers: getHeaders() });

       console.log('response2', res);
       if (res.status == 200) {
         setdurationdata(res.data.result.data);
       }
     } catch (error) {
       console.log(error);
       return;
     }
  };
    let getSubscriptionById = async () => {
      setLoading(true)
      try {
        // let res = await axios.get(`http://192.168.100.16:3200/api/v1/admin/subscribe/get/${subId}`, { headers: getHeaders() });
        // let res = await axios.get(`http://localhost:3200/api/v1/admin/subscribe/get/${subId}`, { headers: getHeaders() });

        let res = await axios.get(`${app.URL}/api/v1/admin/subscribe/get/${subId}`, { headers: getHeaders() });
  setLoading(false);
  console.log("Response", res)
        // console.log(res.data?.result?.data);
  
        res.data?.data ? setUpdatedData(res.data?.data) : '';
        res.data?.data ? setcategoryId(res.data?.data?.productCategoryId) : '';
        res.data?.data ? setdurationId(res.data?.data?.duration) : '';

        res.data?.data ? setUploadedImg(res.data?.data?.image) : '';
        res.data?.data ? setProdDescription(res.data?.data?.description) : '';
        res.data?.data ? setProductCat(res.data?.data?.products.map((item) => item.productId)) : [];


        res.data?.data ? setLoading(false) : ""
        // res.data?.result?.data ? settextEditorValue(res.data?.result?.data?.description) : '';
      } catch (err) {
        console.log(err);
      }
  };
  

     const getfacialPackages = async (id) => {
       try {
         const res = await axios.get(`${app.URL}/api/v1/admin/facialpackages/view`, { headers: getHeaders() });
        //  const res = await axios.get(`http://192.168.100.16:3200/api/v1/admin/facialpackages/view`, { headers: getHeaders() });

         console.log('response2', res);
         if (res.status === 200) {
           let arrresp = [...res.data.result.data]; // Copy array to avoid mutation

           const exists = arrresp.some((item) => item.facialPackageId === updatedDataa?.facialPackageId);

           if (!exists) {
             arrresp.push({
               facialPackageId: updatedDataa?.facialPackageId,
               name: updatedDataa?.facialPackageName,
               scans: updatedDataa?.scans,
               pricing: updatedDataa?.pricing,
             });
           }

           setfacialScandata(arrresp);
         }

        //  if (res.status == 200) {
        //    let arrresp = res.data.result.data
        //    arrresp.push({facialPackageId: updatedDataa?.facialPackageId,name:updatedDataa?.facialPackageName})
        //    res.data.result.data.includes(facialPackageId: updatedDataa?.facialPackageId) ? setfacialScandata(res.data.result.data) : setfacialScandata(arrresp);
           
        //  }
       } catch (error) {
         console.log(error);
         return;
       }
     };
  console.log(prodDescription)
  console.log('facialScandata', facialScandata);
console.log('updatedData', updatedDataa, uploadedImg);

   useEffect(() => {
     getdurations()
     getSubscriptionById()
          // getfacialPackages();

   }, []);
  
   useEffect(() => {
     if (updatedDataa) {
       getfacialPackages();
     }
   }, [updatedDataa]);
  useEffect(() => {
    if (categoryId) {
      setproductsdata([])
      getproductsusingCategoryId(categoryId);
    }
  }, [categoryId]);
  console.log(uploadVideo);
  let navigate = useNavigate();
  const [uploadObj, setUploadObj] = useState({});
  function goBack() {
    navigate('/subscribe/list', { replace: true });
  }
  window.addEventListener('popstate', goBack);

  const user = JSON.parse(localStorage.getItem('user'));
  const subId = localStorage.getItem('subscriptionId');
   

  const uploadData = async (userDetails) => {
    setLoading(true);
    let userId = user?.result.data.user.userId;
    userDetails.userId = userId;
    console.log("User Details", userDetails);
   
    try {
      const res = await axios.post(`${app.URL}/api/v1/admin/subscribe/edit/${subId}`, userDetails, { headers: getHeaders() });
      setLoading(false);
      // setShow(false);

      if (res.data.success) {
        setAddUserResp(res.data.data);
        message.success(res.data.msg);

        setTimeout(goBack, 500);
      } else if (!res.data.result.success) {
        message.warning(res.data.result.msg);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      setShow(false);

      if (err) console.log(err.response.data.message);
      else return;
    }
  };
 
 const getFrequency = async () => {
   try {
     //  const res = await axios.get(`${app.URL}/api/v1/admin/product/getproducts?productCategoryId=${id}`, { headers: getHeaders() });
    //  const res = await axios.get(`http://192.168.100.18:3200/api/v1/admin/duration/get?type=frequency&durationId=${durationId}`, { headers: getHeaders() });
     const res = await axios.get(`${app.URL}/api/v1/admin/duration/get?type=frequency&durationId=${durationId}`, { headers: getHeaders() });

     console.log('response2', res);
     if (res.status == 200) {
       setfrequencydata(res.data.result.data);
     }
   } catch (error) {
     console.log(error);
     return;
   }
 };
 useEffect(() => {
   if (durationId) {
     getFrequency();
   }
 }, [durationId]);
  const onFinish = (values) => {
    console.log(values, 'values');
    // return;
    let products = productCat.map((item) => (typeof item == 'object' ? item.productId : item));
    if (products.length == 0) {
      message.error('Select atleast one product')
      return
    }
    const payload = {
      ...values,
      image: uploadedImg ? uploadedImg : '',
      description: prodDescription,
      patientId: null,
      type: 'system',
      startDate: values.startDate ? values.startDate.format().split('T')[0] : '',
      endDate: values.endDate ? values.endDate.format().split('T')[0] : '',
      productId: products,
      quantity: values?.quantity ? Number(values.quantity) : 1,
    };
    console.log(payload, 'payload');
    // return;

    // setUploadObj(payload)
    // setShow(true)
    if (Object.keys(payload).length > 0) {
      uploadData(payload);
    }
    console.log(payload, 'payload');
    // return;
  };
  const submitData = () => {
    return
  };

   const handleKeyPress = (e) => {
     console.log(e);
     let test = false;

     console.log(e.charCode);
     const keyCode = e.which || e.keyCode;
     // && e.target.value.length<1
     if (e.charCode === 32) {
       console.log('Space key pressed');
       // 32 is the charCode for space key
       e.preventDefault(); // Prevent the default behavior (typing space)
     }
     // Block alphabetic characters (A-Z and a-z)  ((e.charCode >= 65 && e.charCode <= 90) || (e.charCode >= 97 && e.charCode <= 122))
     if (e.charCode >= 58 && e.charCode !== 46) {
       e.preventDefault();
     } else if (e.charCode <= 47 && e.charCode !== 46) {
       e.preventDefault();
     }
   };

  
  const handleClose = () => setShow(false);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const [videoNote, showVideoNote] = useState(false);

  const boxToggleVideo = () => {
    setuploadVideo('');
  };

  // const handleuploadImage = (info) => {
  //   if (info.file.status === 'uploading') {
  //     setimageuploading(true);
  //   }
  //   if (info.file.status === 'done') {
  //     // Get this url from response in real world.
  //     info.file ? console.log(info.file.response.result.data.Location) : console.log('Not found');
  //     info.file ? setuploadImage(info.file.response.result.data.Location) : ' ';
  //     setimageuploading(false);
  //   }
  // };
   const handleProductDescription = (htmlContent) => {
     setProdDescription(htmlContent);
   };

  return (
    <UpdateRecord
      // videoUrl={uploadVideo}
      loading={loading}
      uploadedImg={uploadedImg}
      setUploadedImg={setUploadedImg}
      response={updatedDataa}
      pageTitle='Edit Subscription'
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      handleClose={handleClose}
      show={show}
      addUserResp={addUserResp}
      goBack={goBack}
      initialValues={{
        remember: true,
        ['name']: updatedDataa?.name,
        ['duration']: updatedDataa?.duration,
        ['frequency']: updatedDataa?.frequency,
        ['amount']: updatedDataa?.amount,
        ['facialScans']: updatedDataa?.facialScans,
        ['productCategoryId']: updatedDataa?.productCategoryId,
        ['productId']: updatedDataa?.productId,
        ['facialPackageId']: updatedDataa?.facialPackageId?updatedDataa?.facialPackageId:null,
        ['facialValidity']: updatedDataa?.facialValidity,
        ['quantity']: updatedDataa?.quantity ? updatedDataa?.quantity.toString() : '1',
        ['isActive']: updatedDataa?.isActive,
        ['startDate']: updatedDataa?.startDate ? moment(updatedDataa?.startDate) : moment(),
        ['endDate']: updatedDataa?.endDate && moment(updatedDataa?.endDate),
      }}
      inputs={[
        <InputField
          label='Name'
          name='name'
          col='col-lg-4 col-md-4 col-6'
          required={true}
          placeholder='Name'
          rules={[
            {
              required: true,
              message: 'Enter Name',
            },
          ]}
        />,
        <SelectField
          label='Duration'
          name='duration'
          col='col-lg-3 col-md-3 col-6'
          required={true}
          placeholder='Duration'
          options={durationdata?.map((item) => (
            <Select.Option value={item.id}>{item.name}</Select.Option>
          ))}
          rules={[
            {
              required: true,
              message: 'Select Duration',
            },
          ]}
          onChange={(e) => {
            setdurationId(e);
            setfrequencydata([]);
          }}
        />,
        <SelectField
          label='Frequency'
          name='frequency'
          col='col-lg-3 col-md-3 col-6'
          required={true}
          placeholder='Frequency'
          options={frequencydata?.map((item) => (
            <Select.Option value={item.frequencyId}>{item.frequency}</Select.Option>
          ))}
          rules={[
            {
              required: true,
              message: 'Select Frequency',
            },
          ]}
        />,
        <InputField
          col='col-lg-2 col-md-3 col-12'
          name='amount'
          label='Amount'
          rules={[
            {
              required: true,
              message: 'Amount',
            },
          ]}
          placeholder='Enter Amount'
          required={true}
          // onKeyPress={handleKeyPress}
          // onkeydown={handleKeyPress}
          // onChange={handleKeyPress}
        />,
        // <InputField
        //   label='No. of Steps'
        //   name='noOfSteps'
        //   col='col-lg-2 col-md-3 col-6'
        //   required={true}
        //   placeholder='No. of Steps'
        //   rules={[
        //     {
        //       required: true,
        //       message: 'Enter No. of Steps',
        //     },
        //   ]}
        // />,

        <SelectField
          label='Category'
          name='productCategoryId'
          col='col-lg-4 col-md-3 col-6'
          required={true}
          placeholder='Product Category'
          options={productCategories.map((item) => (
            <Select.Option value={item.productCategoryId}>{item.name}</Select.Option>
          ))}
          rules={[
            {
              required: true,
              message: 'Select Product Category',
            },
          ]}
          onChange={(e) => {
            setcategoryId(e);
            setProductCat([]);
          }}
        />,
        <div className='col-md-6 col-12'>
          <TagSelect
            // options={productCategories?.map((item) => {
            //   if (!productCat?.includes(item.productCategoryId)) {
            //     return <Select.Option value={item.productCategoryId}>{item.name}</Select.Option>;
            //   }
            // })}
            options={productsdata?.map((item) => (
              <Select.Option value={item.productId}>{item.name}</Select.Option>
            ))}
            tags={productCat}
            setTags={setProductCat}
            label='Product'
            cisPanelCode={productsdata}
            isSubscrip={true}
          />
        </div>,
        <InputField
          col='col-lg-2 col-md-3 col-12'
          name='quantity'
          label={<span style={{ whiteSpace: 'nowrap' }}>Quantity Per Frequency</span>}
          // rules={[
          //   {
          //     required: true,
          //     message: 'Enter Quantity',
          //   },
          // ]}
          placeholder='Enter Quantity'
          // required={true}
          onKeyPress={handleKeyPress}
          // onkeydown={handleKeyPress}
          defaultValue={1}
          onChange={handleKeyPress}
        />,

        <SelectField
          name='facialPackageId'
          label='Facial Scan'
          rules={[
            {
              required: false,
              message: 'Facial Scan',
            },
          ]}
          placeholder='Facial Scan'
          col='col-lg-4 col-md-5 col-6'
          required={false}
          allowClear
          options={facialScandata?.map((item) => (
            <Select.Option value={item.facialPackageId}>
              {item.name ? `${item.name} (${item.scans} scans for ${item.pricing})` : null}
            </Select.Option>
          ))}
        />,
        <InputField
          col='col-lg-3 col-md-3 col-12'
          name='facialValidity'
          label={<span style={{ whiteSpace: 'nowrap' }}>Facial Validity</span>}
          // rules={[
          //   {
          //     required: true,
          //     message: 'Enter Quantity',
          //   },
          // ]}
          placeholder='Enter validity in days'
          // required={true}
          onKeyPress={handleKeyPress}
          // onkeydown={handleKeyPress}
          // defaultValue={1}
          onChange={handleKeyPress}
        />,
        <div className='col-8 mb-4'>
          <TestComponent title='Description' textvalue={prodDescription} onChange={handleProductDescription} />
        </div>,
        <div className='col-md-3 media-column mb-3'>
          <label>Image</label>
          <Upload listType='picture-card' className='avatar-uploader ' showUploadList={false} action={`${app.URL}/api/v1/general/product/logoUpload`} beforeUpload={beforeUpload} onChange={handleChange} headers={header}>
            {uploadedImg && !imageuploading ? (
              <img className='added-img' src={uploadedImg} alt='avatar' />
            ) : !uploadedImg && imageuploading ? (
              <LoadingOutlined style={{ fontSize: '40px' }} />
            ) : (
              <div className='d-flex flex-column py-3'>
                <img className='for-add-img' src={AddPhoto} alt='avatar' />
                <p className='add-text'>Upload Image</p>
              </div>
            )}
          </Upload>

          <div className='d-flex align-items-center gap-2'>
            {imgError ? <BiSolidError size={16} color='red' /> : !uploadedImg && !imageuploading && <MdError size={16} color='#f2b544' />}
            <p style={{ fontSize: '14px' }}>{imgError ? 'The image is not between 700-1100 x 1100-2000 px.' : !uploadedImg && !imageuploading && 'Note: Upload image size 2MB with 700-1100 x 1100-2000 px.'}</p>
          </div>
          {uploadedImg && (
            <>
              <button
                style={{ backgroundColor: '#F21D2F' }}
                onClick={() => {
                  setUploadedImg('');
                  setImgError(false);
                }}
                className='add-btn'
              >
                Remove
              </button>
              <br />
              {/* <p>{uploadedImg ? uploadedImg : null}</p> */}
              {/* <input type='text' value={uploadedImg || ''} readOnly /> */}
            </>
          )}

          {/* <small className='mt-2 font-weight-light' style={{ fontSize: '14px' }}>
                           Note: Upload max image size 2MB with 1100 x 2000 px.
                         </small> */}
        </div>,
      ]}
      isCalen={true}
      submitData={submitData}
      switchBtn={true}
      setisActiv={setisActive}
      updateMessage='Are you sure you want to add Subscription?'
    />
  );
};

export default EditSubscription;
